import FacilitiesGrid from './FacilitiesGrid';

export default FacilitiesGrid;